
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1696837955036",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "9300",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "500",
    "height": "500"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M811.304552 584.159919c-116.969595 0-211.74937 95.81186-211.74937 214.157568s94.779775 214.157568 211.74937 214.157568 211.74937-95.81186 211.74937-214.157568-94.779775-214.157568-211.74937-214.157568z m-148.104149 178.894675c20.297665-81.018646 102.864438-130.55871 184.743155-110.433059 54.700487 13.245087 97.532001 55.904586 111.293129 110.433059 0.344028 1.720141 0.172014 3.440282-0.86007 4.816395-0.860071 1.376113-2.408198 2.408198-3.956325 2.752226-1.376113 0.344028-2.752226 0.172014-3.956324-0.344028-89.103309-36.81102-189.387536-36.81102-278.490845 0-3.268268 1.376113-7.052579-0.172014-8.428692-3.268268-0.516042-1.204099-0.516042-2.580212-0.344028-3.956325zM791.694944 942.637326c-0.172014 1.720141-1.032085 3.440282-2.408198 4.472367-1.376113 1.032085-3.096254 1.548127-4.988409 1.204098-62.441122-11.008903-111.465144-59.688896-123.162103-122.130018-0.344028-1.720141 0.172014-3.440282 1.204099-4.988409 1.032085-1.376113 2.752226-2.236183 4.472366-2.408198 3.612296-0.344028 7.224593-0.516042 10.836889-0.516042 114.389384 0 114.389384 0 114.389384 113.529313 0.172014 3.78431 0 7.396607-0.344028 10.836889z m21.673778-115.765497c-15.48127 0-28.210314-12.55703-28.210314-28.0383s12.55703-28.0383 28.210314-28.0383c15.653284 0 28.210314 12.55703 28.210314 28.0383s-12.729044 28.0383-28.210314 28.0383z m25.11406 121.441962c-1.720141 0.344028-3.440282-0.172014-4.988409-1.204098-1.376113-1.032085-2.236183-2.752226-2.408198-4.472367-0.344028-3.612296-0.516042-7.224593-0.516042-10.836889 0-113.529313 0.172014-113.529313 114.389383-113.529313 3.612296 0 7.224593 0.172014 10.836889 0.516042 1.720141 0.172014 3.440282 1.032085 4.472367 2.408198 1.032085 1.376113 1.548127 3.096254 1.204099 4.988409-11.524945 62.441122-60.548967 111.121115-122.990089 122.130018z",
        "p-id": "9301"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M524.385016 794.017134c0-124.022174 84.458928-227.746682 198.160255-256.473039-46.44381-28.726356-97.876029-49.884092-153.092558-60.892995C653.223585 440.356123 712.052411 356.069209 712.052411 258.021166c0-131.246766-105.272636-237.723501-235.14329-237.723501S241.765832 126.602385 241.765832 258.021166c0 98.048043 58.656812 182.162943 142.599698 218.629934C169.003864 519.998656 6.622543 712.138418 6.622543 942.80934h563.002184c-28.554342-42.487485-45.239711-93.74769-45.239711-148.792206z",
        "p-id": "9302"
      }
    }
  ]
})
    }
  